import React from "react";
import PagePropertiesInfo from "./PagePropertiesInfo";
import BackgroundProperties from "../../../components/BackgroundProperties";
import PagePropertiesAnimation from "./PagePropertiesAnimation";
import PagePropertiesSEO from "./PagePropertiesSEO";
import BlogSEOSection from "../../../components/BlogSEOSection";
import PagePropertiesAdvanced from "./PagePropertiesAdvanced";
import AppConstants from "../../../constants/AppConstants";
import UIActions from "../../../actions/UIActions";
import DocumentStore from "../../../document/DocumentStore";
import { COMMANDS } from "../../../document/commands";
import PageUpdate from "../../../vo/PageUpdate";
import { batchPropChanges } from "../../../components/utils/PropsUpdater";

import { useAccountState } from "../../../hooks/query/useAccount";
import PagePropertiesAdvancedSubscribe from "./PagePropertiesAdvancedSubscribe";
import PropertyPanelSectionWrapper from "../../base/PropertyPanelSectionWrapper";

const {
  PANEL_SECTION_PAGE_ADVANCED,
  PANEL_SECTION_PAGE_ANIMATION,
  PANEL_SECTION_PAGE_BG,
  PANEL_SECTION_PAGE_SEO,
  PANEL_SECTION_PAGE_INFO,
} = AppConstants;

const PageProperties = ({ blockContainer, layout, page, viewState }) => {
  const user = useAccountState();

  const _togglePanelSection = (sectionName) => {
    UIActions.togglePagePropertiesSection({ name: sectionName });
  };

  const _onPropUpdate = (propInfo) => {
    const pageId = page.get("id");
    const update = new PageUpdate(pageId);
    const updaterCB = ({ action = null, name, value, addUndo, source }) =>
      update.add(name, value, action, addUndo, source);

    batchPropChanges(propInfo, updaterCB);
    DocumentStore.dispatch({ type: COMMANDS.UPDATE_PAGE, payload: update });
  };

  const isWP = page.get("wp", false);

  const label = `${isWP ? "Template" : "Page"} Info`;
  const activeSection = viewState.get("activeSection");

  return (
    <>
      <PropertyPanelSectionWrapper
        title={label}
        open={activeSection === PANEL_SECTION_PAGE_INFO}
        onSIPanelToggle={() => _togglePanelSection(PANEL_SECTION_PAGE_INFO)}
      >
        <PagePropertiesInfo
          page={page}
          pageId={page.get("id")}
          name={page.get("name")}
          slug={page.get("slug")}
          blockContainer={blockContainer}
        />
      </PropertyPanelSectionWrapper>
      <PropertyPanelSectionWrapper
        title="Page Background"
        open={activeSection === PANEL_SECTION_PAGE_BG}
        onSIPanelToggle={() => _togglePanelSection(PANEL_SECTION_PAGE_BG)}
      >
        <BackgroundProperties
          layout={layout}
          parent={page}
          onPropUpdate={_onPropUpdate}
          videoAllowed={false}
          imageAllowed={false}
        />
      </PropertyPanelSectionWrapper>

      <PropertyPanelSectionWrapper
        title="Animation"
        open={activeSection === PANEL_SECTION_PAGE_ANIMATION}
        onSIPanelToggle={() => _togglePanelSection(PANEL_SECTION_PAGE_ANIMATION)}
      >
        <PagePropertiesAnimation page={page} layout={layout} onPropUpdate={_onPropUpdate} />
      </PropertyPanelSectionWrapper>
      <PropertyPanelSectionWrapper
        title="SEO Settings"
        helpTooltip="seo"
        open={activeSection === PANEL_SECTION_PAGE_SEO}
        onSIPanelToggle={() => _togglePanelSection(PANEL_SECTION_PAGE_SEO)}
      >
        {!isWP ? (
          <PagePropertiesSEO page={page} onPropUpdate={_onPropUpdate} />
        ) : (
          <BlogSEOSection />
        )}
      </PropertyPanelSectionWrapper>

      <PropertyPanelSectionWrapper
        title="Advanced Settings"
        open={activeSection === PANEL_SECTION_PAGE_ADVANCED}
        onSIPanelToggle={() => _togglePanelSection(PANEL_SECTION_PAGE_ADVANCED)}
      >
        {user.get("isActive") || user.get("isAdmin") ? (
          <PagePropertiesAdvanced page={page} onPropUpdate={_onPropUpdate} />
        ) : (
          <PagePropertiesAdvancedSubscribe />
        )}
      </PropertyPanelSectionWrapper>
      {/* scrollbar display bug fix: */}
      <div style={{ flex: "none", height: 4 }} />
    </>
  );
};

export default PageProperties;
